<template>
  <div class="lottie-wrapper">
    <div v-if="!isLoading">
      <lottie-player id="lf1"
        autoplay
        mode="normal"
        src="https://assets7.lottiefiles.com/packages/lf20_Vwcw5D.json"
        style="width: 320px"
      ></lottie-player>
      <h1>Your account is now confirmed!</h1>
      <h3>You can now log in platform</h3>


      <router-link to="/">
        <button type="button" class="btn animation-on-hover btn-success">Go to login</button>
      </router-link>


    </div>
    <div v-if="isLoading">
      <!--      <lottie-player-->
      <!--        autoplay-->
      <!--        loop-->
      <!--        mode="normal"-->
      <!--        src="https://assets8.lottiefiles.com/packages/lf20_4agv4n2o.json"-->
      <!--        style="width: 320px"-->
      <!--      ></lottie-player>-->
      <h3 class="loader-header">Please wait...</h3>
    </div>
  </div>
</template>

<script>
import * as LottiePlayer from '@lottiefiles/vue-lottie-player'
import AuthService from "../services/auth-service";

export default {
  name: "EmailConfirmationPage",
  data() {
    return {
      isLoading: true
    }
  },
  methods: {
    confirmMail(userId, code) {
      AuthService.mailConfirm(userId, code).then(
        response => {
          if (response.status === 200) {
            setTimeout(() => {
              this.isLoading = false;
            }, 1000);
            return Promise.resolve(response.data);
          }
        },
        error => {
          return Promise.reject(error);
        }
      )
    }
  },
  created() {
    this.confirmMail(this.$route.query.userId, this.$route.query.code);
  }
}
</script>

<style scoped lang="scss">
.lottie-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);

  lottie-player {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  h1{
    text-align: center;
  }
  h3 {
    text-align: center;

    &.loader-header {
      margin-top: 1em;
    }
  }

  button {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
